import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
// import banner from '../../assets/images/banner.png';
// import { tabs } from '../../common/tab';
// import { TabComponent } from '../../components/TabComponent';
// import { TabPanel } from '../../components/TabPanel';
// import { MobileAccordion } from '../../components/MobileAccordion';
import { HotelComponent } from './components/HotelComponent';
// import { headerHeight } from '../../common/headerHeight';
// import { colors } from '../../styles/colors';
import { StepperCard } from '../../components/StepperComponent';
import { CustomContainer } from '../../components/CustomContainer';
import { useDispatch, useSelector } from 'react-redux';
import { setStepperState } from '../../features/stepper/stepperSlice';
import useWindowWidth from '../../hooks/useWindowWidth';
import { ApplicationStateType } from '../../features/store';
import { useAppSelector } from '../../hooks/useAppReducer';
import ReturnToOffer from '../../components/ReturnToOffer';
import { setShowPopup } from '../../features/commonState';
import { getLocalStorage } from '../../helpers/storage';
import { getCookie } from '../../helpers/cookieUtils';
import { colors } from '../../styles/colors';

export default function Home() {
  const dispatch = useDispatch();
  let existingData: any[] = [];
  const cookieData = getCookie("sharedCookieData");
  if (cookieData) {
    try {
      const parsed = JSON.parse(decodeURIComponent(cookieData));
      existingData = Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      existingData = [];
    }
  }
  // const popupData = JSON.parse(getLocalStorage("searchCriteria") || "{}");
  const hasPopupData = existingData && Object.keys(existingData).length > 0;
  const { storePayload, showPopup } = useSelector((state: any) => state.commonState);
  const { holidayPackage } = useAppSelector((state: ApplicationStateType) => state.holidayPackage);
  const windowWidth = useWindowWidth()
  useEffect(() => {
    if (
      Object.keys(holidayPackage).length === 0 ||
      holidayPackage?.Packages?.results?.length === 0 ||
      storePayload === undefined
    ) {
      dispatch(setShowPopup(hasPopupData));
    }
    dispatch(setStepperState(0));
  }, [dispatch]);

  return (
    <Box position='relative' bgcolor={colors.basics.secondary}>
      <Box
        // mb={{ xs: '16px' }}
        pt={{ xs: windowWidth < 376 ? '44px' : '60px', sm: '0' }}
      >
      </Box>
      <Box>
        <CustomContainer style={{ maxWidth: '1368px !important' }} >
          {/* <StepperCard /> */}
          <Typography variant='body1' fontSize='16px' fontWeight={400} lineHeight='130%' py='16px' >
            Home / Holidays
          </Typography>
        </CustomContainer>
        <HotelComponent />
      </Box>
      {/* <Box >
        {showPopup &&(
          <ReturnToOffer />
        )}
      </Box> */}
    </Box>
  );
}
